var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6424 26.6497C20.8215 26.6497 26.6413 22.3463 26.6413 17.0377C26.6413 11.7292 20.8215 7.42578 13.6424 7.42578C6.46334 7.42578 0.643555 11.7292 0.643555 17.0377C0.643555 22.3463 6.46334 26.6497 13.6424 26.6497Z",
    fill: "url(#paint0_linear_5580_23055)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83271 3.97544C2.60171 5.62514 1.28617 7.85252 1.28617 10.255C1.28617 12.6576 2.60171 14.8849 4.83271 16.5346C7.06356 18.1842 10.176 19.2239 13.6419 19.2239C17.1079 19.2239 20.2203 18.1842 22.4512 16.5346C24.6822 14.8849 25.9977 12.6576 25.9977 10.255C25.9977 7.85252 24.6822 5.62514 22.4512 3.97544C20.2203 2.32584 17.1079 1.28617 13.6419 1.28617C10.176 1.28617 7.06356 2.32584 4.83271 3.97544ZM4.06801 2.94129C6.54183 1.11203 9.92883 0 13.6419 0C17.3551 0 20.7421 1.11203 23.2159 2.94129C25.6895 4.77043 27.2839 7.34902 27.2839 10.255C27.2839 13.1611 25.6895 15.7397 23.2159 17.5688C20.7421 19.398 17.3551 20.5101 13.6419 20.5101C9.92883 20.5101 6.54183 19.398 4.06801 17.5688C1.59435 15.7397 0 13.1611 0 10.255C0 7.34902 1.59435 4.77043 4.06801 2.94129Z",
    fill: "url(#paint1_linear_5580_23055)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5580_23055",
    x1: 29.8738,
    y1: 0.806306,
    x2: 1.36381,
    y2: 29.3163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5580_23055",
    x1: 22.1826,
    y1: 1.71536,
    x2: 5.10227,
    y2: 18.7957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D6F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFFC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.19fd3ff8a0007b6a554c9f079cf343ef.svg";
export { ForwardRef as ReactComponent };